import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Pagination from 'src/components/atoms/pagination/pagination';
import Spinner from 'src/components/atoms/spinner/spinner';
import Table from 'src/components/atoms/table/table';
import { useAppDispatch, useAppSelector } from 'src/reducers';
import { getParamsFromUrl, setParamsToUrl, userDefaultParams } from 'src/utils/pagination-utils';
import { getUsers } from '../../../reducers/user.reducer';
import styles from './timesheets.module.scss';
import { TimesheetsTableCardUser } from './timesheetsTableUser/timesheetsTableCardUser';
import { TimesheetsTableHeaderUser } from './timesheetsTableUser/timesheetsTableHeaderUser';

const Timesheets = () => {
  const dispatch = useAppDispatch();
  const { users, totalItems, refresh, loading, success, failure } = useAppSelector(state => state.user);
  const navigate = useNavigate();
  const location = useLocation();

  const [params, setParams] = useState(getParamsFromUrl(userDefaultParams, location));

  const handlePagination = (page: number) => {
    setParams(prevState => ({
      ...prevState,
      currentPage: page + 1,
    }));
  };

  useEffect(() => {
    dispatch(getUsers({ pagination: params }));
    setParamsToUrl(params, navigate);
  }, [dispatch, navigate, params, params.currentPage, params.sortBy, params.sortDirection, refresh]);

  if (loading) {
    return <Spinner className={styles.spinner} />;
  }

  return (
    <div>
      <>
        {!loading && failure && <div className="m-1">Errore nel caricamento dei rapportini</div>}
        {!loading && success && users.length === 0 && <div className="m-1">Nessun utente trovato.</div>}
        {!loading && success && users.length > 0 && (
          <>
            <Table>
              <Table.Header>
                <TimesheetsTableHeaderUser />
              </Table.Header>
              <Table.Body>
                {users.map(user => (
                  <TimesheetsTableCardUser user={user} key={user.id} />
                ))}
              </Table.Body>
            </Table>
            <Pagination
              activePage={params.currentPage - 1}
              itemsPerPage={params.postPerPage}
              totalItems={totalItems || 0}
              paginate={handlePagination}
            />
          </>
        )}
      </>
    </div>
  );
};

export default Timesheets;
